import { membershipsData } from 'src/data';
import { Box, Typography, Button, ExplorerPlusIcon } from 'src/components';

export default function PlanSwitch({ selectedTier, onSelect }) {
    return (
        <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
            <Box
                sx={{
                display: "flex",
                alignItems: "center",
                bgcolor: "#e8ecef",
                borderRadius: 50,
                p: 0.25,
                boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                }}
            >
                {Object.keys(membershipsData).map((tier) => (
                    <Button
                        key={tier}
                        variant="text"
                        size="small"
                        onClick={() => onSelect(tier)}
                        startIcon={
                            <ExplorerPlusIcon 
                                tier={tier.toLowerCase()}
                                size={22}
                                variant={tier === "Plus" ? "static" : "animated"}
                            />
                        }
                        sx={{
                            borderRadius: 50,
                            px: 1.5,
                            py: 0.7,
                            minWidth: "auto",
                            bgcolor: selectedTier === tier ? "white" : "transparent",
                            color: "text.primary",
                            "& .MuiButton-startIcon": { marginRight: "6px" },
                            "&:hover": {
                                bgcolor: selectedTier === tier ? "white" : "rgba(255,255,255,0.4)",
                            },
                        }}>
                        <Typography
                            variant="subtitle1"
                            fontWeight={selectedTier === tier ? 600 : 400}
                            >
                            {tier}
                        </Typography>
                    </Button>
                ))}
            </Box>
        </Box>
    );
}